import { z } from 'zod';

import { staticMessageSchema } from './standard-schema';

export type User = z.infer<typeof userSchema>;
export const userSchema = z.object({
  id: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  full_name: z.string(),
  username: z.string(),
  email: z.string(),
  onboarding_state: z.number(),
  tz_name: z.string(),
  tz_offset: z.number(),
  email_verified: z.boolean(),
  verification_deadline: z.string().optional(),
  created_at: z.string().datetime(),
  promo_code: z.string().optional(),
  is_professional: z.boolean().optional(),
  role: z.string().optional(),
  organization: z.object({
    id: z.coerce.string().optional(),
    name: z.string().optional(),
  }),
});

export type UserTimeZone = z.infer<typeof userTimeZoneSchema>;
export const userTimeZoneSchema = z.object({
  name: z.string(),
  offset: z.number(),
});

// TODO remove after goal deployment
export type UserAddress = z.infer<typeof userAddressSchema>;
export const userAddressSchema = z.object({
  line1: z.string().optional(),
  line2: z.string().optional(),
  line3: z.string().optional(),
  country: z.string(),
  postal_code: z.string(),
  city: z.string().optional(),
  region: z.string().optional(),
});

export interface UserAddressPayload extends Partial<UserAddress> {
  country: string;
}

export const unverifiedPhoneSchema = z.object({
  verified: z.literal(false),
});

export const verifiedPhoneSchema = z.object({
  phone_masked: z.string(),
  e164_last4: z.string(),
  verified: z.literal(true),
  channel: z.string(),
});

export const userPhoneSchema = z.discriminatedUnion('verified', [
  unverifiedPhoneSchema,
  verifiedPhoneSchema,
]);

export type UserPhone = z.infer<typeof userPhoneSchema>;

export interface StartPhoneVerificationPayload {
  phone: string;
}

export interface ConfirmPhoneVerificationPayload
  extends StartPhoneVerificationPayload {
  code: string;
}

export const user = {
  user: { path: `u/v1/user`, schema: userSchema },
  updateUser: {
    path: (userId?: string) => `u/v1/user/${userId}`,
    schema: userSchema,
  },
  userTimezone: { path: `u/v1/tz`, schema: staticMessageSchema },
  address: { path: `u/v1/address`, schema: userAddressSchema },
  phone: {
    get: { path: `u/v2/phone`, schema: userPhoneSchema },
    startVerification: { path: `u/v2/phone/verify/start` },
    confirmVerification: { path: `u/v2/phone/verify/confirm` },
    delete: { path: `u/v2/phone` },
  },
};
